import HacizInjectable from "./HacizInjectable";
import {MDB} from "../MDB";
import {
    BakiyeBorcMuhtirasininTebligeCikartilmasiParamsInterface,
    IcraOdemeEmrininTebligeCikartilmasiParamsInterface,
    KiymetTakdirininTebligeCikartilmasiParamsInterface,
    TaahhuduKabulMuhtirasiTebligiParamsInterface, TemlikbilgisininBildirilmesiParamsInterface,
    YenilemeEmrininTebligeCikartilmasiParamsInterface,
    YuzucDavetiyesininTebligeCikartilmasiParamsInterface
} from "./TebligatParamsInterface";
import {TebligatEvrakTypeEnum} from "../uyap/enum/TebligatEvrakTypeEnum";
import TakipDosya from "@/plugins/uyap-plugin/uyap/classes/TakipDosya";
import {
    canliTebligatTuruBul,
    TEBLIGAT_TEMEL_ALANLARI,
    TebligatTalepAlani,
    TebligatTuruSatiri
} from "../utils/tebligatTalepUtils";

const mdb = new MDB();

interface TebligatTemelParams {
    tebligatTuru: number,
    adresTuru: number,
    adresTuruAciklama: string,
    adres: string
}

export default class TebligatController extends HacizInjectable {
    /** UYAP'ın bu avukata gönderim anında verdiği tebligat türü listesi (fresh). */
    tebligatTurleri: TebligatTuruSatiri[];

    constructor(borclu: any, dosya: TakipDosya, tebligatTurleri: TebligatTuruSatiri[]) {
        super(borclu, dosya);
        this.tebligatTurleri = tebligatTurleri;
    }

    /**
     * Talep nesnesini UYAP portalının kurduğu gibi kurar. Alan sırası ve değerler portalın
     * gönderimiyle aynı (TDT-3528 HAR, getIcraTalepEvrakHazirla ve
     * avukatIcraTalepEvrakiGonder): talep bilgileri, tebligatTuruAciklama, tebligatTuru,
     * adresTuru, adresTuruAciklama, adres, türe özgü alanlar, masraf, fields, id.
     *
     * Tür adı ve ücret görevdeki değerlerden ya da MDB'den değil, canlı listedeki aynı
     * satırdan alınır (DEV-3519). evrakTutar, portaldaki gibi talep masraflarının toplamıdır.
     */
    private tebligatTalebiEkle(className: string, params: TebligatTemelParams, turAlanlari: object = {}, turFields: TebligatTalepAlani[] = []) {
        let obj = mdb.tebligat.talepListesi.find((i: any) => i.className == className);
        let tur = canliTebligatTuruBul(this.tebligatTurleri, params.tebligatTuru);
        let talepObj = Object.assign({}, obj, {
            "tebligatTuruAciklama": tur.masrafAdi,
            "tebligatTuru": tur.postaMasraflariId,
            "adresTuru": params.adresTuru,
            "adresTuruAciklama": params.adresTuruAciklama,
            "adres": params.adres
        }, turAlanlari, {
            "masraf": tur.fiyati,
            "fields": TEBLIGAT_TEMEL_ALANLARI.concat(turFields),
            // Aynı evrakta birden çok talep olabilir; UYAP id'nin dizideki sırayla artmasını bekliyor.
            "id": this.talepBilgileri.length
        });
        this.evrakTutar += tur.fiyati + Number(obj.talepMasrafi || 0);
        this.talepBilgileri.push(talepObj);
    }

    yuz3DavetiyesininTebligeCikartilmasiEkle(params: YuzucDavetiyesininTebligeCikartilmasiParamsInterface) {
        this.tebligatTalebiEkle(TebligatEvrakTypeEnum.YUZUCDAVETIYESININ_TEBLIGE_CIKARTILMASI, params, {
            "hacizTarihi": params.hacizTarihi,
            "malTip": params.malTip,
            "malTipAciklama": params.malTipAciklama,
            "aciklama": params.aciklama
        }, [
            {id: "hacizTarihi", title: "Haciz Tarihi"},
            {id: "malTipAciklama", title: "Mal Tip"},
            {id: "aciklama", title: "Açıklama"}
        ]);
    }

    bakiyeBorcMuhtirasininTebligeCikartilmasiEkle(params: BakiyeBorcMuhtirasininTebligeCikartilmasiParamsInterface) {
        this.tebligatTalebiEkle(TebligatEvrakTypeEnum.BakiyeBorcMuhtirasininTebligeCikartilmasi, params);
    }

    icraOdemeEmrininTebligeCikartilmasiEkle(params: IcraOdemeEmrininTebligeCikartilmasiParamsInterface) {
        this.tebligatTalebiEkle(TebligatEvrakTypeEnum.IcraOdemeEmrininTebligeCikartilmasi, params);
    }

    yenilemeEmrininTebligeCikartilmasiEkle(params: YenilemeEmrininTebligeCikartilmasiParamsInterface) {
        this.tebligatTalebiEkle(TebligatEvrakTypeEnum.YenilemeEmrininTebligeCikartilmasi, params);
    }

    kiymetTakdirininTebligeCikartilmasiEkle(params: KiymetTakdirininTebligeCikartilmasiParamsInterface) {
        this.tebligatTalebiEkle(TebligatEvrakTypeEnum.KiymetTakdirininTebligeCikartilmasi, params, {
            "kiymetTakdirTarihi": params.kiymetTakdirTarihi,
            "malTip": params.malTip,
            "malTipAciklama": params.malTipAciklama,
            "aciklama": params.aciklama
        }, [
            {id: "kiymetTakdirTarihi", title: "Kıymet Takdir Tarihi"},
            {id: "aciklama", title: "Açıklama"},
            {id: "malTipAciklama", title: "Mal Türü"}
        ]);
    }

    taahhuduKabulMuhtirasiTebligiEkle(params: TaahhuduKabulMuhtirasiTebligiParamsInterface) {
        this.tebligatTalebiEkle(TebligatEvrakTypeEnum.TaahuduKabulMuhtirasiTebligi, params, {
            "taahhutTarihi": params.taahhutTarihi,
            "aciklama": params.aciklama
        }, [
            {id: "taahhutTarihi", title: "Taahhüt Tarihi"},
            {id: "aciklama", title: "Açıklama"}
        ]);
    }

    temlikbilgisininBildirilmesiEkle(params: TemlikbilgisininBildirilmesiParamsInterface) {
        this.tebligatTalebiEkle(TebligatEvrakTypeEnum.TemlikBilgisininBildirilmesi, params, {
            "kismiTemlikMi": params.kismiTemlikMi,//boolean
            "kismiTemlikMiStr": params.kismiTemlikMi ? "Evet" : "Hayır",
            "temlikAlacakli": params.temlikAlacakliKisiKurumId,
            "temlikAlacakliStr": params.temlikAlacakliAdi,
            "temlikEdilen": params.temlikEdilen,
            "temlikTipi": params.temlikTipi,
            "temlikTutarTuru": params.temlikTutarTuru,
            "temlikTutarTuruStr": params.temlikTutarTuru,
            "temlikTutari": params.temlikTutari
        }, [
            // Portalda ayrıca {id: "temlikTutariSTR", title: "Temlik Tutarı"} var; bu alanı
            // göndermediğimiz için listeye eklenmedi.
            {id: "kismiTemlikMiStr", title: " Kısmı Temlik"},
            {id: "temlikAlacakliStr", title: "Alacaklı"},
            {id: "temlikEdilen", title: "Temlik Edilen"}
        ]);
    }
}
